import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../context-state/AuthContext';
import { PATH_DASHBOARD } from '../routes/paths';
import { useRole, ROLES_LABELS } from '../pages/common/guards/RoleGuard';

export default function DashboardRedirect() {
    const { user } = useAuthContext();
    const { getUserRole } = useRole();

    // If user is a promoter, redirect to promoter page
    if (user?.isPromoter) {
        return <Navigate to={PATH_DASHBOARD.promoter} replace />;
    }

    // If user is a cashier or scanner, redirect to cashier page
    const role = getUserRole();
    if (role === ROLES_LABELS.CASHIER || role === ROLES_LABELS.SCANNER) {
        return <Navigate to={PATH_DASHBOARD.cashier} replace />;
    }

    // Otherwise, redirect to main dashboard
    return <Navigate to={PATH_DASHBOARD.main} replace />;
} 